var _mask, _g, _mask2, _g2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColor(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 49,
    viewBox: "0 0 100 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logo-color_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 8,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.123 47.927h2.346c.291-5.012 2.067-10.34 5.117-15.502C3.952 37.499 1.411 42.777.123 47.927z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-color_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo-color_svg__wave",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.123 47.927h2.346c.291-5.012 2.067-10.34 5.117-15.502C3.952 37.499 1.411 42.777.123 47.927z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-color_svg__wave logo-color_svg__wave--gradient",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.123 47.927h2.346c.291-5.012 2.067-10.34 5.117-15.502C3.952 37.499 1.411 42.777.123 47.927z",
    fill: "url(#logo-color_svg__paint0_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "logo-color_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 56,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.325 4.556C64.44-2 82.241 2.142 88.275 14.568c4.499 9.271 1.422 21.973-7.519 33.359h10.6c8.012-11.344 10.572-23.675 5.596-33.366C92.073 5.054 80.996.128 67.606.128c-7.284 0-15.252 1.458-23.28 4.428z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo-color_svg__wave",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.325 4.556C64.44-2 82.241 2.142 88.275 14.568c4.499 9.271 1.422 21.973-7.519 33.359h10.6c8.012-11.344 10.572-23.675 5.596-33.366C92.073 5.054 80.996.128 67.606.128c-7.284 0-15.252 1.458-23.28 4.428z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-color_svg__wave logo-color_svg__wave--gradient",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.325 4.556C64.44-2 82.241 2.142 88.275 14.568c4.499 9.271 1.422 21.973-7.519 33.359h10.6c8.012-11.344 10.572-23.675 5.596-33.366C92.073 5.054 80.996.128 67.606.128c-7.284 0-15.252 1.458-23.28 4.428z",
    fill: "url(#logo-color_svg__paint1_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.303 19.303c3.61 0 4.185-2.327 4.185-3.453 0-2.712-2.188-3.335-4.26-3.335H16.5l.002 6.784 2.802.004zm-9.87 15.514V7.437h11.714c4.877 0 9.447 2.48 9.447 8.182 0 1.666-.654 8.34-10.6 8.34H16.5v10.858H9.433zM60.78 21.126c0-5.584 3.955-9.23 9.37-9.23 1.493 0 2.731.29 3.748.664l2.704-4.698c-2.495-.851-5.53-1.124-7.298-1.124-10.023 0-15.898 6.593-15.898 14.698 0 9.89 8.103 14.078 15.094 14.078 3.34 0 4.952-.425 6.028-.738l3.302-5.739c-1.843.814-4.57 1.474-7.028 1.474-7.027 0-10.023-4.77-10.023-9.385zM10.782 40.92H9.421v-1.238h4.13v1.238h-1.362v7.036h-1.407V40.92zM14.945 47.957v-8.275h1.407v3.37h1.498v-3.37h1.408v8.275H17.85v-3.669h-1.498v3.669h-1.407zM21.186 47.957v-8.275h3.768v1.238h-2.361v2.132h1.815v1.236h-1.815v2.431h2.519v1.238h-3.926zM28.199 43.395h.499c.76 0 1.044-.286 1.044-1.271 0-.987-.285-1.273-1.044-1.273h-.5v2.544zm0 4.562H26.79v-8.275h1.975c1.577 0 2.383.676 2.383 2.442 0 1.328-.51 1.867-.987 2.084l1.191 3.75h-1.43l-.998-3.428a6.746 6.746 0 01-.726.034v3.393zM34.264 44.885H35.4l-.555-3.553h-.024l-.556 3.553zm-.453 3.072h-1.363l1.51-8.275h1.748l1.51 8.275h-1.362l-.25-1.834H34.06l-.25 1.834zM40.006 43.395h.544c.92 0 1.203-.286 1.203-1.271 0-.987-.283-1.273-1.203-1.273h-.544v2.544zM38.6 47.957v-8.275h2.02c1.736 0 2.542.676 2.542 2.442 0 1.764-.806 2.44-2.542 2.44h-.613v3.393H38.6zM44.615 47.957v-8.275h3.768v1.238h-2.36v2.132h1.815v1.236h-1.816v2.431h2.52v1.238h-3.927zM50.22 39.682h1.407v6.246c0 .608.238.905.749.905s.749-.297.749-.905v-6.246h1.407v6.19c0 1.42-.817 2.2-2.156 2.2-1.34 0-2.156-.78-2.156-2.2v-6.19zM57.277 40.92h-1.361v-1.238h4.13v1.238h-1.362v7.036h-1.407V40.92zM61.635 47.956h1.407v-8.274h-1.407v8.274zM68 42.444v-.642c0-.7-.318-.998-.68-.998-.569 0-.75.298-.75.918v4.196c0 .617.181.916.75.916.51 0 .68-.299.68-.837v-.998h1.407v.951c0 1.17-.68 2.12-2.088 2.12-1.475 0-2.156-.95-2.156-2.12v-4.263c0-1.169.68-2.12 2.156-2.12 1.408 0 2.088 1.032 2.088 2.27v.607H68zM73.969 41.722c-.057-.71-.432-.917-.75-.917-.454 0-.703.298-.703.814 0 1.41 2.86 2.086 2.86 4.333 0 1.364-.908 2.119-2.224 2.119-1.307 0-2.055-1.055-2.112-2.291l1.34-.195c.056.836.385 1.249.839 1.249.489 0 .818-.264.818-.757 0-1.64-2.86-2.073-2.86-4.447 0-1.317.794-2.062 2.178-2.062 1.147 0 1.828.837 1.953 2.006l-1.34.148zM39.387 34.818V12.836h-7.754v-5.39h22.534v5.39h-7.676v21.982h-7.104zM96.653 46.165h.432c.139 0 .256-.031.348-.094a.297.297 0 00.141-.26c0-.143-.036-.243-.107-.303-.072-.06-.201-.092-.388-.094h-.426v.75zm0 .408v1.03h-.456v-2.594h.849c.307 0 .549.068.722.205.173.138.26.334.26.589 0 .237-.122.421-.363.549a.524.524 0 01.275.257.99.99 0 01.079.418c0 .166.003.282.01.352.007.069.02.128.04.175v.048h-.468c-.026-.069-.039-.265-.039-.591 0-.155-.033-.266-.1-.335-.067-.068-.177-.103-.332-.103h-.477zm2.208-.233a2 2 0 00-.226-.94 1.782 1.782 0 00-.641-.695 1.668 1.668 0 00-.906-.262c-.32 0-.618.084-.894.251-.274.166-.49.396-.647.689a1.994 1.994 0 00-.236.957c0 .345.078.665.235.958.155.293.37.525.646.693.275.17.574.255.896.255.322 0 .621-.085.9-.258.275-.174.49-.407.643-.698.154-.293.23-.61.23-.95zm-3.919.001c0-.41.094-.791.284-1.143a2.117 2.117 0 011.862-1.135c.387 0 .746.101 1.079.303.332.202.592.48.781.832.187.352.282.733.282 1.143a2.4 2.4 0 01-.282 1.145c-.19.353-.448.63-.779.835-.33.205-.69.307-1.081.307-.39 0-.748-.101-1.081-.305a2.162 2.162 0 01-.78-.834 2.387 2.387 0 01-.285-1.148z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-color_svg__paint0_linear",
    x1: 3.467,
    y1: 23.539,
    x2: 6.789,
    y2: 56.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-color_svg__paint1_linear",
    x1: 72.485,
    y1: 18.454,
    x2: 74.957,
    y2: 43.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84B38"
  })))));
}

export default SvgLogoColor;